"use client";

import { useTranslations } from "next-intl";
import Link from "next/link";

export default function NotFound() {
  const t = useTranslations("NotFound");

  return (
    <div className="min-h-[calc(100vh-590px)] mt-[120px] flex items-center justify-center px-4 py-10">
      <div className="max-w-2xl text-center">
        <h1 className="text-6xl font-semibold mb-4">404</h1>
        <p className="text-lg text-gray-600 mb-8">{t("error")}</p>

        <Link
          href="/"
          className="inline-flex items-center justify-center gap-2
                     rounded-full bg-blue px-8 py-3
                     text-sm font-medium text-white
                     transition-all duration-200
                     hover:bg-blue-dark hover:scale-[1.03]"
        >
          {t("returnHome")}
        </Link>
      </div>
    </div>
  );
}
